
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 43 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M27.587 24.163l-7.925-11.18-2.655 1.59a1.358 1.358 0 01-1.406-.008l-3.136-1.93-7.92 11.173c.34.234.642.356.879.356h22.163zm1.984-1.837v-2.35c0-.736.602-1.332 1.345-1.332s1.345.596 1.345 1.332v5.016c0 1.013-.83 1.837-1.853 1.837H5.423c-1.257 0-2.365-.638-3.427-1.675-.467-.456-1.245-1.385-1.127-1.269a2.445 2.445 0 01-.389-.501 2.5 2.5 0 01-.353-1.147 24.703 24.703 0 01-.026-1.075V5.833c0-.261.006-.705.014-1.046.019-.639.205-1.498.724-2.377C1.721.917 3.279.007 5.475.007h22.681c.642 0 1.378.307 1.825.762l1.542 1.564a2.73 2.73 0 01.738 1.796v5.225c0 .736-.602 1.332-1.345 1.332s-1.345-.597-1.345-1.332V7.05l-7.601 4.551 7.601 10.725zm-26.773-.693l7.376-10.408-7.383-4.542V21.16c0 .133.002.304.006.473zM0 30.685v-.023-1.333h32.318v2.665H0v-1.31zM29.432 4.019c-.209-.217-.654-.666-1.333-1.347-.012-.012-7.553-.012-22.623-.002-1.228 0-1.909.398-2.314 1.084l-.009.015 13.168 8.102L29.433 4.02zM43.063 30.64v1.356h-8.092v-2.665h8.092v1.31zM30.189 15.969a1.286 1.286 0 01-1.293-1.281c0-.704.577-1.28 1.293-1.28h8.017l-1.455-1.491a1.266 1.266 0 01-.072-1.809 1.322 1.322 0 011.842-.071l3.626 3.703c.011.01.014.026.025.036.013.014.031.018.048.031.042.047.058.108.095.158l.019.031.005.011c.044.064.091.123.119.19.037.086.044.165.061.253.016.077.037.152.037.231 0 .083-.021.157-.037.234v.004c-.004.011-.004.027-.007.036-.013.07-.024.143-.054.21-.022.052-.056.096-.086.149-.03.048-.061.096-.094.143-.025.028-.033.067-.058.095-.018.015-.035.022-.048.036-.011.012-.014.021-.025.033l-3.626 3.704a1.317 1.317 0 01-1.842-.07 1.269 1.269 0 01.072-1.813l1.441-1.473h-8.003z"}})])
          )
        }
      }
    